import { IMAGE_ALT, imageSizeProps } from '../../seo/imageAltText';
import PictureImage from '../../components/Common/PictureImage';
import React from 'react';
import { Link } from 'react-router-dom';
import './SFPCards.css';

const SFPCards: React.FC = () => {
  const cards: { id: number; icon: string; title: string; description: React.ReactNode }[] = [
    {
      id: 1,
      icon: '/Images/sfp-automation-icon.webp',
      title: 'Automated Seller Fulfilled Prime Fulfilment',
      description: (
        <>
          Our Seller Fulfilled Prime UK fulfilment system automates order processing for fast dispatch and accurate{' '}
          <Link to="/blog/pick-and-pack-fulfilment-uk-explained">pick and pack</Link>, with full Amazon SFP
          compliance.
        </>
      ),
    },
    {
      id: 2,
      icon: '/Images/sfp-order-fulfilment-icon.webp',
      title: 'Order Management',
      description: (
        <>
          Manage SFP orders with real-time visibility via{' '}
          <Link to="/wms-integrations">WMS integrations</Link> and seamless Amazon Seller Central workflows.
        </>
      ),
    },
    {
      id: 3,
      icon: '/Images/sfp-tracking-icon.webp',
      title: 'Real-Time Tracking',
      description:
        'Track every Seller Fulfilled Prime shipment with live updates, delivery notifications, and complete visibility for you and your Amazon customers.',
    },
  ];

  return (
    <section className="sfp-cards-section">
      <div className="sfp-cards-container">
        <div className="sfp-cards-grid">
          {cards.map((card) => (
            <div key={card.id} className="sfp-card">
              <div className="sfp-card-icon-wrapper">
                <PictureImage 
                  src={card.icon} 
                  alt={IMAGE_ALT.sfpCard(card.title)}
                  className="sfp-card-icon" {...imageSizeProps(card.icon)} loading="lazy" />
              </div>
              <h3 className="sfp-card-title">{card.title}</h3>
              <p className="sfp-card-description">{card.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SFPCards;
